module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "form-body-follow"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    staticClass: "total-title",
    staticStyle: {
      "width": "33%"
    }
  }, [_c('a', {
    staticClass: "color-brown",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.clickFollowing
    }
  }, [_vm._v(_vm._s(_vm.numberWithCommas(_vm.following[1])))])]), _c('td', {
    staticClass: "total-title",
    staticStyle: {
      "width": "33%"
    }
  }, [_c('a', {
    staticClass: "color-green",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.clickFollowed()
      }
    }
  }, [_vm._v(_vm._s(_vm.numberWithCommas(_vm.followed[1])))])]), _c('td', {
    staticClass: "total-title",
    staticStyle: {
      "width": "33%"
    }
  }, [_c('a', {
    staticClass: "color-red",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.clickFavoriteAnswer()
      }
    }
  }, [_vm._v(_vm._s(_vm.numberWithCommas(1250)) + "/" + _vm._s(_vm.numberWithCommas(2120)))])])]), _vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "txt-follow"
  }, [_vm._v("Đang theo dõi")]), _c('td', {
    staticClass: "txt-follow"
  }, [_vm._v("Được theo dõi ")]), _c('td', {
    staticClass: "txt-follow"
  }, [_vm._v("Câu trả lời được yêu thích")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a66d070","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserProfile/Follow.vue
// module id = 1519
// module chunks = 0